import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=07e1f5a0&scoped=true"
import script from "./IssueList.vue?vue&type=script&lang=js"
export * from "./IssueList.vue?vue&type=script&lang=js"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=07e1f5a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e1f5a0",
  null
  
)

export default component.exports